export const Patterns = {
	"Circular Grid": 11,
	"Covering Lines": 12,
	"Spiral": 15,
	"No Pattern": 0,
};
